<!--
/*
 * Компонент SupportButton — кнопка связи с поддержкой
 */
-->
<script lang="ts" setup>
import { useSupportContact } from '@/components/support-button/useSupportContact'
import { useI18n } from 'vue-i18n'

const { contactViaTelegram, contactViaEmail } = useSupportContact()
const { t } = useI18n()
</script>

<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        variant="flat"
        color="surface"
        class="text-on-surface"
        rounded="lg"
        block
        prepend-icon="ri-chat-3-line"
      >
        {{ t('nav.support') }}
      </v-btn>
    </template>

    <v-list density="compact">
      <v-list-item
        prepend-icon="ri-telegram-line"
        :title="t('support.writeTelegram')"
        @click="contactViaTelegram"
      />
      <v-list-item
        prepend-icon="ri-mail-line"
        :title="t('support.writeEmail')"
        @click="contactViaEmail"
      />
    </v-list>
  </v-menu>
</template>
